const translations = {
    es: {
        // Login
        login_title: 'Sistema de Gestión Profesional',
        login_email: 'Correo Electrónico',
        login_password: 'Contraseña',
        login_submit: 'Iniciar Sesión',
        login_loading: 'Iniciando sesión...',
        login_customer: '✨ Soy Cliente / Ver mis Puntos',
        login_rep: '📈 Soy Vendedor / Portal de Comisiones',
        login_distributor: '📦 Soy Distribuidor / Portal de Pedidos',
        login_register: '🚀 Registrar mi CarWash gratis (14 días)',
        login_terms: 'Al continuar, aceptas los términos de servicio',
        login_new_biz: '¿Nuevo negocio?',
        login_register_web: '¿Tu car wash aún no tiene cuenta? Regístrate en',
        login_error_invalid: 'Correo o contraseña incorrectos.',
        login_show_pass: 'Mostrar contraseña',
        login_hide_pass: 'Ocultar contraseña',
        login_forgot: '¿Olvidaste tu contraseña?',
        login_reset_invalid: 'El enlace de recuperación no es válido o ya expiró. Pide uno nuevo con "¿Olvidaste tu contraseña?".',

        // ForgotPassword / UpdatePassword
        fp_title: 'Recuperar contraseña',
        fp_subtitle: 'Te enviaremos un enlace para crear una nueva',
        fp_email: 'Correo Electrónico',
        fp_submit: 'Enviar enlace de recuperación',
        fp_sending: 'Enviando...',
        fp_resend_in: 'Reenviar en',
        fp_success: 'Si el correo existe, recibirás un enlace en unos minutos. Revisa también el spam.',
        fp_back: '← Volver a iniciar sesión',
        up_checking: 'Verificando enlace...',
        up_title: 'Nueva contraseña',
        up_subtitle: 'Crea la nueva contraseña de tu cuenta',
        up_new: 'Nueva contraseña',
        up_confirm: 'Confirmar contraseña',
        up_minlen: 'La contraseña debe tener al menos 6 caracteres.',
        up_mismatch: 'Las contraseñas no coinciden.',
        up_submit: 'Guardar contraseña',
        up_saving: 'Guardando...',
        up_done_title: 'Contraseña actualizada',
        up_done_body: 'Abre la app CarWash Pro e inicia sesión con tu nueva contraseña.',
        up_go_login: 'Ir a iniciar sesión',

        // CustomerLogin
        cl_title: 'Portal de Clientes',
        cl_subtitle: 'Ingresa para ver tus puntos y membresías',
        cl_otp_title: 'Código de verificación',
        cl_select_title: '¿A cuál negocio quieres acceder?',
        cl_phone_label: 'Número de teléfono',
        cl_phone_placeholder: '787-000-0000',
        cl_search: 'Buscar mi cuenta',
        cl_searching: 'Buscando...',
        cl_otp_sent: 'Enviamos un código de 6 dígitos a tu WhatsApp',
        cl_otp_label: 'Código de verificación',
        cl_otp_placeholder: 'Ingresa el código de 6 dígitos',
        cl_verify: 'Verificar código',
        cl_verifying: 'Verificando...',
        cl_resend: 'Reenviar código',
        cl_resending: 'Enviando...',
        cl_back: 'Atrás',
        cl_select_sub: 'Tu número está registrado en {n} negocios. Escoge uno.',
        cl_select_placeholder: '¿A cuál quieres entrar?',
        cl_continue: 'Continuar',
        cl_not_found: 'No encontramos ese número. Verifica que esté registrado.',
        cl_rate_limit: 'Demasiados intentos. Espera un momento.',
        cl_phone_invalid: 'Por favor ingresa un número de teléfono válido.',

        // SalesRepLogin
        rep_title: 'Portal de Vendedores',
        rep_subtitle: 'Ingresa con tu correo y código de vendedor',
        rep_email: 'Correo electrónico',
        rep_code: 'Código de vendedor',
        rep_submit: 'Entrar al portal',
        rep_loading: 'Verificando...',
        rep_no_access: '¿No tienes acceso? Contacta a CarWash Pro',

        // SalesRepPortal
        rp_active_biz: 'Negocios activos',
        rp_mrr: 'Mi regalía/mes',
        rp_pending: 'Pendiente cobro',
        rp_paid_total: 'Total cobrado',
        rp_link_label: 'Tu link de registro',
        rp_copy: 'Copiar',
        rp_copied: 'Copiado',
        rp_my_biz: 'Mis Negocios Inscritos',
        rp_no_biz: 'Aún no has inscrito negocios.',
        rp_no_biz_sub: 'Comparte tu link para empezar a ganar regalías.',
        rp_per_month: 'por mes',
        rp_commissions: 'Historial de Comisiones',
        rp_paid_badge: 'Pagado',
        rp_pending_badge: 'Pendiente',
        rp_logout: 'Salir',

        // Layout nav
        nav_dashboard: 'Dashboard',
        nav_commissions: 'Comisiones',
        nav_services: 'Servicios',
        nav_customers: 'Clientes',
        nav_reports: 'Reportes Globales',
        nav_audit_history: 'Historial de Cambios',
        nav_employees: 'Empleados',
        nav_expenses: 'Gastos',
        nav_memberships: 'Membresías',
        nav_promotions: 'Promociones',
        nav_settings: 'Marca y Configuración',
        nav_billing: 'Facturación / Plan',
        nav_whatsapp: 'Agente WhatsApp',
    },

    en: {
        // Login
        login_title: 'Professional Management System',
        login_email: 'Email',
        login_password: 'Password',
        login_submit: 'Sign In',
        login_loading: 'Signing in...',
        login_customer: "✨ I'm a Customer / View my Points",
        login_rep: '📈 Sales Rep / Commission Portal',
        login_distributor: '📦 Distributor / Orders Portal',
        login_register: '🚀 Register my CarWash free (14 days)',
        login_terms: 'By continuing, you agree to the terms of service',
        login_new_biz: 'New business?',
        login_register_web: "Your car wash doesn't have an account yet? Sign up at",
        login_error_invalid: 'Incorrect email or password.',
        login_show_pass: 'Show password',
        login_hide_pass: 'Hide password',
        login_forgot: 'Forgot your password?',
        login_reset_invalid: 'The recovery link is invalid or has expired. Request a new one with "Forgot your password?".',

        // ForgotPassword / UpdatePassword
        fp_title: 'Reset your password',
        fp_subtitle: "We'll email you a link to create a new one",
        fp_email: 'Email',
        fp_submit: 'Send recovery link',
        fp_sending: 'Sending...',
        fp_resend_in: 'Resend in',
        fp_success: 'If the email exists, you will receive a link within a few minutes. Check your spam folder too.',
        fp_back: '← Back to sign in',
        up_checking: 'Verifying link...',
        up_title: 'New password',
        up_subtitle: 'Create the new password for your account',
        up_new: 'New password',
        up_confirm: 'Confirm password',
        up_minlen: 'Password must be at least 6 characters.',
        up_mismatch: 'Passwords do not match.',
        up_submit: 'Save password',
        up_saving: 'Saving...',
        up_done_title: 'Password updated',
        up_done_body: 'Open the CarWash Pro app and sign in with your new password.',
        up_go_login: 'Go to sign in',

        // CustomerLogin
        cl_title: 'Customer Portal',
        cl_subtitle: 'Sign in to view your points and memberships',
        cl_otp_title: 'Verification Code',
        cl_select_title: 'Which business do you want to access?',
        cl_phone_label: 'Phone number',
        cl_phone_placeholder: '787-000-0000',
        cl_search: 'Find my account',
        cl_searching: 'Searching...',
        cl_otp_sent: 'We sent a 6-digit code to your WhatsApp',
        cl_otp_label: 'Verification code',
        cl_otp_placeholder: 'Enter the 6-digit code',
        cl_verify: 'Verify code',
        cl_verifying: 'Verifying...',
        cl_resend: 'Resend code',
        cl_resending: 'Sending...',
        cl_back: 'Back',
        cl_select_sub: 'Your number is registered in {n} businesses. Choose one.',
        cl_select_placeholder: 'Which one do you want to enter?',
        cl_continue: 'Continue',
        cl_not_found: 'We could not find that number. Check that it is registered.',
        cl_rate_limit: 'Too many attempts. Please wait a moment.',
        cl_phone_invalid: 'Please enter a valid phone number.',

        // SalesRepLogin
        rep_title: 'Sales Rep Portal',
        rep_subtitle: 'Sign in with your email and rep code',
        rep_email: 'Email',
        rep_code: 'Rep code',
        rep_submit: 'Enter portal',
        rep_loading: 'Verifying...',
        rep_no_access: 'No access? Contact CarWash Pro',

        // SalesRepPortal
        rp_active_biz: 'Active businesses',
        rp_mrr: 'My royalty/mo',
        rp_pending: 'Pending payment',
        rp_paid_total: 'Total paid',
        rp_link_label: 'Your registration link',
        rp_copy: 'Copy',
        rp_copied: 'Copied',
        rp_my_biz: 'My Enrolled Businesses',
        rp_no_biz: "You haven't enrolled any businesses yet.",
        rp_no_biz_sub: 'Share your link to start earning royalties.',
        rp_per_month: 'per month',
        rp_commissions: 'Commission History',
        rp_paid_badge: 'Paid',
        rp_pending_badge: 'Pending',
        rp_logout: 'Sign out',

        // Layout nav
        nav_dashboard: 'Dashboard',
        nav_commissions: 'Commissions',
        nav_services: 'Services',
        nav_customers: 'Customers',
        nav_reports: 'Global Reports',
        nav_audit_history: 'Change History',
        nav_employees: 'Employees',
        nav_expenses: 'Expenses',
        nav_memberships: 'Memberships',
        nav_promotions: 'Promotions',
        nav_settings: 'Branding & Settings',
        nav_billing: 'Billing / Plan',
        nav_whatsapp: 'WhatsApp Agent',
    },
};

export default translations;
